import { render } from "./InstallmentsProgress.vue?vue&type=template&id=5d50d25a"
import script from "./InstallmentsProgress.vue?vue&type=script&lang=js"
export * from "./InstallmentsProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__